import GoDaddyLogo from './GoDaddyLogo';
export default GoDaddyLogo;
